import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=122f0944&"
import script from "./BaseCalendar.vue?vue&type=script&lang=js&"
export * from "./BaseCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BaseCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
